<template>
  <div id="Active">Active View</div>
</template>

<script>
export default {
    name: 'Active',
    components: {},
    data: () => ({}),
    computed: {},
    methods: {},
    mounted() {}
};
</script>
